<template>
  <div>
    <el-form :inline="true" ref="form" size="mini" label-width="150px">
      <el-form-item :label="$t('dayinmobanmingcheng')" required>
        <el-select @change="change" v-model="printTemplateId" placeholder="请选择">
          <el-option v-for="printTemplate in printTemplateList" :label="printTemplate.name"
                     :value="printTemplate.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('picihao')">
        <el-input disabled v-model="printObj.batchNo"></el-input>
      </el-form-item>
      <el-form-item :label="$t('baozhuangguize')">
        <el-select :multiple="false" :clearable="true" v-model="defaultPackageRuleId" @change="changePackageRule"
                   placeholder="请选择">
          <el-option v-for="packageRule in packageRuleList" :label="packageRule.code+'|'+packageRule.name"
                     :value="packageRule.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('baozhuangshuliang')" required>
        <el-input-number @change="packageNumberChange" v-model="printObj.packageNumber" :min="1" step-strictly
                         :max="printObj.planQuantity - (printObj.printedQuantity ? printObj.printedQuantity : 0)"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('jihuashuliang')">
        <el-input v-model="printObj.planQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('yidayinshuliang')">
        <el-input v-model="printObj.printedQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('shengyudayinshuliang')">
        <el-input v-model="printObj.printableQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('dayinzhangshu')">
        <el-input-number :min="1" :max="maxCount?maxCount:50" step-strictly v-model="printCount"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('lingliaoqitaoshu')">
        <el-input v-model="erpNum" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('kehumingcheng')">
        <el-input :value="printObj.plan && printObj.plan.customerName" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('jihuayirukushuliang')">
        <el-input v-model="erpPlanNum" disabled></el-input>
      </el-form-item>

    </el-form>
    <yi_print_preview v-if="printTemplateId" :printTemplateId.sync="printTemplateId" :scale="4" :printDatas="printDatas"
                      ref="yiPrintPreview" @finishPrint="finishPrint" @failedPrint="failedPrint"></yi_print_preview>
    <div style="text-align: center;padding: 20px 0;">
      <el-button :loading="printLoading" @click="$emit('closeDialog')" style="width: 130px;">{{
          $t('quxiao')
        }}
      </el-button>
      <el-button :loading="printLoading" type="primary" @click="print" style="width: 130px;">{{
          printLoading?$t('dayinzhong'):$t('dayin')
        }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      printDatas: [],
      printLoading: false,
      printTemplateList: [],
      printTemplateId: null,
      packageRuleList: [],
      defaultPackageRuleId: null,
      printCount: null,
      printData: {},
      printRecordList: [],
      printObj: null,
      erpNum: 0,
      erpPlanNum: 0,
      maxCount: 50,
    };
  },
  created() {
    this.$set(this, 'printObj', this.$attrs.printObj)
    // this.printObj = this.$attrs.printObj;
    this.defaultPackageRuleId = null;
    //获取标签内容
    this.http.post('/web/print/record/getStandardPrintInformation', {
      woId: this.printObj.id,
      labelType: 11
    }).then(res => {
      this.$set(this.printObj, 'currentOrder', res.data.currentOrder);
      this.$set(this.printObj, 'printedQuantity', res.data.printedQuantity);
      this.$set(this.printObj, 'batchNo', res.data.printData.productionBatchNumber);
      this.$set(this, 'printData', res.data.printData);
      if (!this.printObj.printedQuantity) {
        this.printObj.printedQuantity = 0;
      }
      this.printObj.printableQuantity = this.printObj.planQuantity - (this.printObj.printedQuantity ? this.printObj.printedQuantity : 0);
      //获取包装规则列表
      this.http.get('/web/basic/package_rule/pageByMaterial?pageNum=1&pageSize=99999&orderBy=createTime%20desc&materialId=' + this.$attrs.printObj.materialId).then(res2 => {
        this.packageRuleList = res2.data.rows;
        if (this.packageRuleList.length > 0) {
          this.$set(this, 'defaultPackageRuleId', this.packageRuleList[0].id);
          this.changePackageRule();
        }
      });
      //获取ERP齐套数
      this.http.get('/custom/weier/print/record/getErpNum?woId=' + this.printObj.id).then(res3 => {
        this.erpNum = res3.data;
        if (this.erpNum > 0) {
          this.$set(this, 'erpNum', this.erpNum);
        }
      });
      //获取ERP计划已入库数
      this.http.get('/custom/weier/print/record/getErpPlanNum?woId=' + this.printObj.id).then(res4 => {
        this.erpPlanNum = res4.data;
        if (this.erpPlanNum > 0) {
          this.$set(this, 'erpPlanNum', this.erpPlanNum);
        }
      })
    }).catch(err => {
          this.$message.error(err);
    });

    //获取打印模板列表
    this.http.post('/web/print/template/listWeierPrintTemplate', this.$attrs.printObj).then(res => {
      let itemList = res.data;
      // itemList = itemList.sort((a, b) => {
      //   return b.updateTime - a.updateTime;
      // });
      this.printTemplateList = itemList;
      if (this.printTemplateList.length > 0) {
        setTimeout(() => {
          this.$set(this, 'printTemplateId', this.printTemplateList[0].id);
          this.printDatas = [];
          this.printDatas.push(this.printData);
        }, 800);

      }
    });
    //获取系统管理-生产配置【单次打印标签张数】
    this.http.get('/web/production/config/list?type=15').then(res => {
      if (res.data && res.data.length === 1 && res.data[0].status) {
        this.maxCount = res.data[0].overValue;
      } else {
        this.maxCount = 50;
      }
    }).catch(err => {
      this.$message.error(this.$t(err));
    });
  },
  methods: {
    print() {
      if (!this.printTemplateId) {
        this.$message.error(this.$t('qingxuanzedayinmoban'));
        return;
      }
      if (!this.printObj.packageNumber) {
        this.$message.error(this.$t('baozhuangshuliang') + this.$t('不能为空'));
        return;
      }
      this.printObj.businessType = 11;
      this.printObj.woNo = this.printObj.no;
      this.printObj.woId = this.printObj.id;
      this.printLoading = true;
      //获取批量打印的标签号
      this.http.post('/custom/weier/print/record/getStandardBatchPrintInformation', {
        woId: this.printObj.id,
        printCount: this.printCount,
        packageNumber: this.printObj.packageNumber
      }).then(res => {
        this.printDatas = [];
        this.printRecordList = [];
        for (let item of res.data) {
          let print = this.utils.copy(this.printObj);
          print.currentOrder = item.currentOrder;
          print.labelBarcodeNumber = item.labelBarcodeNumber;
          print.templateId = this.printTemplateId;
          print.createBy = null;
          print.createTime = null;
          print.updateBy = null;
          print.updateTime = null;
          let printDataTemp = this.utils.copy(this.printData);
          printDataTemp.labelBarcodeNumber = item.labelBarcodeNumber;
          printDataTemp.cartonNumber = item.labelBarcodeNumber;//维尔箱号=条码号
          printDataTemp.cartonQuantity = item.currentOrder;
          printDataTemp.quantity = this.printObj.packageNumber;
          printDataTemp.sanchuanQcode = item.printData.sanchuanQcode;
          printDataTemp.pengyaoQrcode = item.printData.pengyaoQrcode;
          printDataTemp.pengyaoSn = item.printData.pengyaoSn;
          printDataTemp.shitouSncode = item.printData.shitouSncode;
          printDataTemp.shitouQrcode = item.printData.shitouQrcode;
          printDataTemp.kumaSerialNum = item.printData.kumaSerialNum;
          printDataTemp.kumaLpn = item.printData.kumaLpn;
          printDataTemp.kumaQrcode = item.printData.kumaQrcode;
          this.printDatas.push(printDataTemp);
          if(item.printData.kumaSerialNum) {
            this.$set(print,"attribute1", item.printData.kumaSerialNum);
          }
          this.printRecordList.push(print);
        }
        setTimeout(() => {
          // 新增批量打印记录
          this.http.post('/web/print/record/batchCreatePrintRecord', this.printRecordList).then(res => {
          }).catch(err => {
            this.$message.error(err);
          }).finally(() => {
          });
          this.$message.success(this.$t('dayinzhong'));
          this.$refs.yiPrintPreview.print();
        }, 500);
      }).catch(err => {
        this.printLoading = false;
        this.printDatas = [];  // 清空打印数据
        this.printRecordList = [];
        this.$message.error(err);
      });
    },
    finishPrint() {
      this.$message.success(this.$t('chenggong'));
      this.$emit('closeDialog');
      this.printLoading = false;
    },
    failedPrint(){
      this.printLoading = false;
    },
    change() {
      this.printDatas = [];
      this.printDatas.push(this.printData);
    },
    changePackageRule() {
      this.http.get('/web/basic/package_rule/page?pageNum=1&pageSize=1&id=' + this.defaultPackageRuleId).then(res => {
        if (res.data.rows.length > 0) {
          let itemList = res.data.rows[0].itemList;
          itemList = itemList.sort((a, b) => {
            return b.sort - a.sort;
          });
          this.printObj.packageNumber = itemList[0].quantity;
          this.printData.quantity = this.printObj.packageNumber;
          this.printData.sanchuanQcode = this.printData.customerMaterialCode + '&' + this.printObj.packageNumber + '&' + this.printData.productionDate
              + '&' + this.printData.cartonQuantity.toString().padStart(6, '0');
          this.printData.pengyaoQrcode = this.printData.customerOrderNo + '|' + this.printData.customerMaterialCode + '|' + this.printObj.packageNumber
              + '|' + this.printData.productionDate + '|' + this.printData.productionBatchNumber + '|C-2063|C-2063|' + this.printData.pengyaoSn;
          this.printData.shitouQrcode = this.printData.shitouQrcode1 + this.printObj.packageNumber + ',' + (this.printData.shitouQrcode2 ? this.printData.shitouQrcode2:'');
          this.printDatas = [];
          this.printDatas.push(this.printData);
        }
      })
    },
    packageNumberChange() {
      this.printData.quantity = this.printObj.packageNumber;
      this.printData.sanchuanQcode = this.printData.customerMaterialCode + '&' + this.printObj.packageNumber + '&' + this.printData.productionDate
          + '&' + this.printData.cartonQuantity.toString().padStart(6, '0');
      this.printData.pengyaoQrcode = this.printData.customerOrderNo + '|' + this.printData.customerMaterialCode + '|' + this.printObj.packageNumber
          + '|' + this.printData.productionDate + '|' + this.printData.productionBatchNumber + '|C-2063|C-2063|' + this.printData.pengyaoSn;
      this.printData.shitouQrcode = this.printData.shitouQrcode1 + this.printObj.packageNumber + ',' + (this.printData.shitouQrcode2 ? this.printData.shitouQrcode2:'');
      this.printDatas = [];
      this.printDatas.push(this.printData);
    },
  },
}
</script>

<style scoped>

</style>